import { create } from 'zustand';

export const DEFAULT_SEVERITIES = ['INFO', 'WARN', 'ERROR', 'FATAL'];

const createEmptySlideOver = () => ({
    strategyId: null,
    resourceType: null,
    resourceId: null,
    resource: null,
});

/**
 * Global Trading Cockpit view-model state shared across the page.
 * This will later be wired to URL + localStorage persistence.
 */
export const useTradingCockpitStore = create((set) => ({
    selectedAccounts: [],
    selectedStrategies: [],
    globalSeverity: DEFAULT_SEVERITIES,
    perCardSeverity: {},
    tabState: {},
    slideOverState: createEmptySlideOver(),
    activitySeverity: {
        preTrade: DEFAULT_SEVERITIES,
        postTrade: DEFAULT_SEVERITIES,
    },

    setSelectedAccounts: (selectedAccounts) => set({ selectedAccounts }),
    setSelectedStrategies: (selectedStrategies) => set({ selectedStrategies }),
    setGlobalSeverity: (severity) => set({ globalSeverity: severity }),
    updatePerCardSeverity: (strategyId, severity) =>
        set((state) => ({
            perCardSeverity: {
                ...state.perCardSeverity,
                [strategyId]: severity,
            },
        })),
    setPerCardSeverityMap: (map) =>
        set({
            perCardSeverity: map || {},
        }),
    resetPerCardSeverity: (strategyId) =>
        set((state) => {
            if (!strategyId) {
                return state;
            }
            const next = { ...state.perCardSeverity };
            delete next[strategyId];
            return { perCardSeverity: next };
        }),
    setTabState: (strategyId, tab) =>
        set((state) => ({
            tabState: {
                ...state.tabState,
                [strategyId]: tab,
            },
        })),
    setTabStateMap: (map) =>
        set({
            tabState: map || {},
        }),
    setActivitySeverity: (phase, severity) =>
        set((state) => ({
            activitySeverity: {
                ...state.activitySeverity,
                [phase]: severity,
            },
        })),
    setActivitySeverityMap: (map) =>
        set({
            activitySeverity: map || {
                preTrade: DEFAULT_SEVERITIES,
                postTrade: DEFAULT_SEVERITIES,
            },
        }),
    setSlideOverState: (nextState) =>
        set({
            slideOverState: nextState ?? createEmptySlideOver(),
        }),
    resetSlideOverState: () => set({ slideOverState: createEmptySlideOver() }),
}));
